/**
 * The release number baked in at build time (REACT_APP_VERSION, set from
 * package.json by frontend/.env.production). "dev" under the dev server and
 * in tests, where it is not set.
 */
export const getAppVersion = (): string => process.env.REACT_APP_VERSION || 'dev';
